export const EDIT_MODE_REQUEST = "EDIT_MODE_REQUEST";
export const EDIT_MODE_TRUE = "EDIT_MODE_TRUE";
export const EDIT_MODE_FALSE = "EDIT_MODE_FALSE";